import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SeFeThemesLoader } from 'se-fe-themes';

@Component({
  selector: 'discount-element',
  templateUrl: './discount.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DiscountComponent implements OnInit {

  constructor() {
    SeFeThemesLoader.load({
      supportedThemes: 'light',
      url: 'https://se-fe-angular-services.ui.sportngin.com'
    });
   }

  public ngOnInit(): void {
  }

}
